/* eslint-disable */
// @ts-nocheck
/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as PearusermanagementPearUserManagement from "../pear-user-management/pear-user-management.pb"


export enum ProductContentType {
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  TYPE_PEAR_DECK = "TYPE_PEAR_DECK",
  TYPE_PEAR_ASSESSMENT_TEST = "TYPE_PEAR_ASSESSMENT_TEST",
  TYPE_PEAR_PRACTICE_SET = "TYPE_PEAR_PRACTICE_SET",
}

export enum ContentAvailability {
  ALL = "ALL",
  PRIVATE = "PRIVATE",
  SHARED = "SHARED",
}

export type GetContentPreviewRequest = {
  product: PearusermanagementPearUserManagement.Product | null
  content_type: ProductContentType | null
  id: string
}

export type GetContentPreviewResponse = {
  url: string
}

export type GetContentLLMContextRequest = {
  product: PearusermanagementPearUserManagement.Product | null
  content_type: ProductContentType | null
  id: string
}

export type GetContentLLMContextResponse = {
  llm_context: string
}

export type SearchContentRequest = {
  term: string
  product: PearusermanagementPearUserManagement.Product | null
  standard_ids: string[]
  availability: ContentAvailability | null
}

export type SearchContentEntity = {
  product: PearusermanagementPearUserManagement.Product | null
  content_type: ProductContentType | null
  id: string
  title: string
  /**
   * Whether the content may be embedded in an iframe. If the product is
   * able to generate a pre-signed URL for embedding the content into
   * any PDL product or interface, return true. If a user shows intent
   * to preview the entity, a request will be made to the product to
   * retrieve the pre-signed URL for use in realizing that outcome.
   */
  can_embed: boolean
  /**
   * Whether the product can provide LLM structured context for the entity
   * for use in an LLM prompt. If a user shows intent to retrieve LLM context
   * for the entity, a request will be made to the product to retrieve the
   * LLM context and the context will be provided to the user.
   */
  can_provide_llm_context: boolean
  created_at: string | null
  updated_at: string | null
}

export type SearchContentResponse = {
  entities: SearchContentEntity[] | null
}


